export default function textHighlight(Vue) {
    Vue.directive('textHighlight', {
        bind(el, binding) {
            judgeFn(el, binding)
        },

        update(el, binding) {
            judgeFn(el, binding)
        }
    })
}

function judgeFn(el, binding) {
    const tbodyEls = el.querySelectorAll('tbody')
    const {
        keyword,
        highlightColor,
        indexs,
        isBegin, // 该参数的作用：防止数据重复更新
    } = Object.assign({
        keyword: '',
        highlightColor: '#009688',
        indexs: [],
        isBegin: false
    }, binding.value)
    if (tbodyEls.length === 0 || !isBegin) {
        return false
    } else {
        for (const tbodyEl of tbodyEls) {
            engineStarter(tbodyEl, indexs, keyword, highlightColor)
        }

        return true
    }
}

function engineStarter(tbodyEl: Element, indexs: number[], keyword: string, highlightColor: string) {
    if (indexs.length === 0) {
        highlightEl(tbodyEl, keyword, highlightColor)
    } else {
        const trs = tbodyEl.querySelectorAll('tr')
        for (const tr of trs) {
            const tds = tr.querySelectorAll('td')
            indexs.forEach((i: number) => {
                const td = tds[i]
                if (td != null) {
                    highlightEl(td, keyword, highlightColor)
                }
            })
        }
    }
}

function highlightEl(el: Element | ChildNode, keyword: string, highlightColor: string) {
    if (el.nodeType === 1) {
        for (const child of el.childNodes) {
            highlightEl(child, keyword, highlightColor)
        }
    } else if (el.nodeType === 3) {
        if (el.textContent && el.textContent.includes(keyword)) {
            let parent: HTMLElement | null = el.parentElement
            if (parent == null) {
                return
            }
            if (parent.getAttribute('data-highlightmark') === '') {
                const lastTwoparent = parent.parentElement
                const lastThreeparent = parent.parentElement && parent.parentElement.parentElement
                if (lastTwoparent != null && lastThreeparent != null && lastTwoparent.textContent != null) {
                    el = document.createTextNode(lastTwoparent.textContent)
                    parent = lastThreeparent
                    lastThreeparent.replaceChild(el, lastTwoparent)
                }
            }
            const newNode = createNewNode(el.textContent, keyword, highlightColor)
            if (newNode != null) {
                parent.replaceChild(newNode, el)
            }
        }
    } else {
        return
    }
}

function createNewNode(text: string | null, keyword: string, highlightColor: string) {
    if (text == null || keyword === '') {
        return
    }
    const result = text.replace(new RegExp(keyword, 'g'), (k: string) => {
        return `<span data-highlightmark style="font-weight: bolder; color: ${highlightColor}">${k}</span>`
    })
    const span = document.createElement('span')
    span.innerHTML = result

    return span
}
